module.exports = __webpack_public_path__ + "static/img/ThinkPad_P51.08a59b18.png";